import type { BhanzuBuddyProps } from '../bhanzu-buddy';
import { UI_CONSTANTS } from '../constants';

export const isBraveBrowser = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  const nav = navigator as Navigator & { brave?: { isBrave?: boolean } };
  return Boolean(nav.brave?.isBrave) || navigator.userAgent.includes('Brave');
};

export const getDefaultInitialPosition = () => {
  const isMobile = globalThis.innerWidth < 640; // sm breakpoint

  // On mobile: bottom-right position for floating FAB (buddy + notification icons)
  if (isMobile) {
    return {
      x: globalThis.innerWidth - 130,
      y: globalThis.innerHeight - 136,
    };
  }

  // On desktop: maintain existing centered bottom position
  return {
    x: Math.max(
      UI_CONSTANTS.DEFAULT_POSITION.MIN_X,
      globalThis.innerWidth / 2 -
        (globalThis.innerWidth < 768
          ? UI_CONSTANTS.DEFAULT_POSITION.MOBILE_OFFSET
          : UI_CONSTANTS.DEFAULT_POSITION.DESKTOP_OFFSET)
    ),
    y:
      globalThis.innerHeight -
      (globalThis.innerWidth < 1024
        ? UI_CONSTANTS.DEFAULT_POSITION.MOBILE_OFFSET
        : UI_CONSTANTS.DEFAULT_POSITION.Y_OFFSET),
  };
};

export const getEffectiveInitialPosition = (
  initialPosition?: BhanzuBuddyProps['initialPosition']
) => initialPosition ?? getDefaultInitialPosition();
